export const MESSAGE_FEATURE_KEY = 'message';
